module.exports = __webpack_public_path__ + "img/wild-rag-deck-01.214d9b48.jpeg";